import React from "react"
import RegisterGoogleSimple from "../../../common/GoogleOriginalDesign/Hotelslabo/Simple/RegisterGoogleSimple"

export default function GoogleRegisterKanto() {
    return (
        <RegisterGoogleSimple
            reasonPoint1Images={[
                {
                    src: "/pages/google/hotelslabo/register_kanto/reason_point1_img1.png",
                    alt: "関東の限定求人詳細1枚目",
                },
                {
                    src: "/pages/google/hotelslabo/register_kanto/reason_point1_img2.png",
                    alt: "関東の限定求人詳細2枚目",
                },
                {
                    src: "/pages/google/hotelslabo/register_kanto/reason_point1_img3.png",
                    alt: "関東の限定求人詳細3枚目",
                }
            ]}
            signupPath='signup?channel=hotel_googleadwords'
        />
    )
}
